'use client';
'use strict';

var _tslib = require('../../../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var tailwindMerge = require('tailwind-merge');
var FullBleed_utils = require('./FullBleed.utils.js');

/**
 * 화면 전체 너비를 활용하는 레이아웃 컴포넌트
 * @param {Object} props
 * @param {ReactNode} props.children - 내부 컨텐츠
 * @param {string} [props.maxWidth] - 최대 너비 설정
 * @param {string} [props.className] - 외부 컨테이너 클래스
 * @param {string} [props.insideContainerClassName] - 내부 컨테이너 클래스
 * @param {string | number} [props.paddingAdjustment] - 패딩 보정값(단위 : px)
 */ const FullBleed = react.forwardRef((_a, ref)=>{
    var { className, insideContainerClassName, maxWidth = '1200px', paddingAdjustment = 8.5, children } = _a, rest = _tslib.__rest(_a, [
        "className",
        "insideContainerClassName",
        "maxWidth",
        "paddingAdjustment",
        "children"
    ]);
    // TODO: 스크롤바 너비를 제외한 viewport width 계산을 더 나은 방식으로 할 수 있도록 개선(layout shift 방지)
    const [scrollBarWidth, setScrollBarWidth] = react.useState(()=>{
        const calculatedScrollbarWidth = FullBleed_utils.calculateScrollbarWidth();
        return calculatedScrollbarWidth;
    });
    const mobilePadding = FullBleed_utils.getPaddingFromClassName(insideContainerClassName, 'mobile');
    const tabletPadding = FullBleed_utils.getPaddingFromClassName(insideContainerClassName, 'tablet');
    const desktopPadding = FullBleed_utils.getPaddingFromClassName(insideContainerClassName, 'desktop');
    react.useEffect(()=>{
        setScrollBarWidth(FullBleed_utils.calculateScrollbarWidth());
    }, []);
    const dynamicStyle = {
        '--dynamic-padding-left-tablet': `max(${tabletPadding.left || tabletPadding.x}px, ${mobilePadding.left || mobilePadding.x}px)`,
        '--dynamic-padding-right-tablet': `max(${tabletPadding.right || tabletPadding.x}px, ${mobilePadding.right || mobilePadding.x}px)`,
        '--dynamic-padding-left-desktop': `calc(max(calc((100dvw - ${maxWidth})/2 + ${mobilePadding.left || mobilePadding.x}px + ${paddingAdjustment}px), ${desktopPadding.x}px))`,
        '--dynamic-padding-right-desktop': `calc(max(calc((100dvw - ${maxWidth})/2 + ${mobilePadding.right || mobilePadding.x}px + ${paddingAdjustment}px), ${desktopPadding.x}px))`
    };
    const dynamicViewportWidth = {
        '--dynamic-bleed-width': `calc(100dvw - ${scrollBarWidth}px)`
    };
    return jsxRuntime.jsx("div", {
        "data-testid": "design-system-full-bleed",
        children: jsxRuntime.jsx("div", {
            "data-testid": "design-system-full-bleed--container",
            className: tailwindMerge.twMerge(`relative left-1/2 top-0 h-full w-[var(--dynamic-bleed-width)] -translate-x-1/2`, className),
            style: dynamicViewportWidth,
            children: jsxRuntime.jsx("div", Object.assign({
                "data-testid": "design-system-full-bleed--container-inside",
                className: tailwindMerge.twMerge('flex w-full overflow-x-auto px-5 scrollbar-hide', 'tablet:pl-[var(--dynamic-padding-left-tablet)] tablet:pr-[var(--dynamic-padding-right-tablet)]', 'desktop:pl-[var(--dynamic-padding-left-desktop)] desktop:pr-[var(--dynamic-padding-right-desktop)]', insideContainerClassName),
                style: dynamicStyle,
                ref: ref
            }, rest, {
                children: children
            }))
        })
    });
});
FullBleed.displayName = 'FullBleed';

module.exports = FullBleed;
